export default {"src":"/_next/static/media/callout-note.ea7cc13a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};